export var JAVASCRIPT_ERROR = 'javascript_error';
export var NETWORK_ERROR = 'network_error'; // Limiting to only most common network status error codes.

export var NETWORK_ERROR_STATUS_CODES = [400, 401, 403, 422, 500, 502, 503, 504];